var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M5 1.09c-.76.3-1.4.69-2.04 1.33a5.64 5.64 0 0 0-1.33 2.04 8.43 8.43 0 0 0-.54 2.8A81.24 81.24 0 0 0 1.02 12c0 3.13.02 3.52.07 4.75.06 1.23.26 2.07.54 2.8.3.76.69 1.4 1.33 2.04A5.65 5.65 0 0 0 5 22.94c.73.28 1.57.47 2.8.53 1.23.06 1.62.07 4.75.07 3.14 0 3.53-.01 4.76-.07a8.55 8.55 0 0 0 2.8-.53c.76-.3 1.4-.7 2.04-1.34a5.65 5.65 0 0 0 1.33-2.04c.29-.73.48-1.57.54-2.8.05-1.23.07-1.62.07-4.75s-.02-3.53-.07-4.75a8.55 8.55 0 0 0-.54-2.8c-.3-.76-.69-1.4-1.33-2.04a5.65 5.65 0 0 0-2.04-1.33 8.43 8.43 0 0 0-2.8-.54 81.23 81.23 0 0 0-4.75-.07C9.43.48 9.03.5 7.8.55A8.32 8.32 0 0 0 5 1.1Zm12.21 1.53c1.13.06 1.74.24 2.15.4.54.21.92.46 1.32.87.4.4.65.78.87 1.32.15.41.34 1.02.4 2.14.05 1.22.06 1.58.06 4.66s-.01 3.45-.07 4.66a6.35 6.35 0 0 1-.4 2.15 3.6 3.6 0 0 1-.86 1.32c-.4.4-.78.65-1.32.86-.41.16-1.02.35-2.15.4-1.21.06-1.58.07-4.66.07s-3.44-.02-4.65-.07a6.35 6.35 0 0 1-2.15-.4 3.6 3.6 0 0 1-1.32-.86 3.6 3.6 0 0 1-.87-1.32 6.35 6.35 0 0 1-.4-2.15 79.83 79.83 0 0 1-.06-4.66c0-3.08.01-3.44.07-4.66.05-1.12.23-1.73.4-2.14.2-.54.45-.92.86-1.32.4-.4.78-.66 1.32-.87.41-.16 1.02-.34 2.15-.4 1.2-.05 1.57-.06 4.65-.06s3.45 0 4.66.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M6.63 12.01a5.92 5.92 0 1 0 11.84 0 5.92 5.92 0 0 0-11.84 0Zm9.77 0a3.84 3.84 0 1 1-7.69 0 3.84 3.84 0 0 1 7.69 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654C9F",
    d: "M18.71 7.24a1.38 1.38 0 1 0 0-2.76 1.38 1.38 0 0 0 0 2.76Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(33.3 -1.75 1.48 28.3 1.44 21.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(17.1 -.9 .76 14.53 6.85 16.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.e76ec57712dd81abf59e2737b6d5d5be.svg";
export { ForwardRef as ReactComponent };